import { render } from "./ChangeRouter.vue?vue&type=template&id=e9dfff82"
import script from "./ChangeRouter.vue?vue&type=script&lang=js"
export * from "./ChangeRouter.vue?vue&type=script&lang=js"
script.render = render

export default script